export type ColorScheme = 'light' | 'dark' | 'contrast';

export type ThemeMode = ColorScheme | 'system';

export const THEME_STORAGE_KEY = 'dnk-mode';

const SCHEME_CLASSES: Record<ColorScheme, readonly string[]> = {
  light: [],
  dark: ['dark'],
  contrast: ['dark', 'contrast'],
};

const MANAGED_CLASSES = ['dark', 'contrast'];

export const isThemeMode = (value: unknown): value is ThemeMode =>
  value === 'system' || Object.hasOwn(SCHEME_CLASSES, value as string);

export const resolveColorScheme = (mode: ThemeMode, systemDark: boolean): ColorScheme => {
  if (mode !== 'system') return mode;
  return systemDark ? 'dark' : 'light';
};

export const isDarkScheme = (scheme: ColorScheme) => SCHEME_CLASSES[scheme].includes('dark');

export const colorSchemeClassName = (scheme: ColorScheme) => (
  isDarkScheme(scheme) ? SCHEME_CLASSES[scheme] : ['light', ...SCHEME_CLASSES[scheme]]
).join(' ');

export const applyColorScheme = (scheme: ColorScheme) => {
  const { classList } = document.documentElement;
  MANAGED_CLASSES.forEach((name) => classList.toggle(name, SCHEME_CLASSES[scheme].includes(name)));
};
